<template>
  <div
    class="border-b border-solid border-racq-white my-2"
    :style="inlineStyle"
    :class="outerClass"
    :data-test-id="dataTestId"
  ></div>
</template>

<script setup lang="ts">
import { usePageStore } from '@/store';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';

const props = defineProps<{
  outerClass?: string;
  rendering?: ComponentRendering;
}>();

const outerClass = `${props.outerClass ?? ''} ${props.rendering?.params?.Styles ?? ''}`.trim();
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);
</script>
